<template>
  <div
    class="flex items-center gap-2 rounded px-1 transition"
    :class="{ 'bg-lexmea-selection-lightest font-bold': active }"
  >
    <SchemaIcon
      v-if="showIcon"
      class="-mt-[.55rem] h-4 w-3 flex-shrink-0"
      :focus="active"
      :filled="active"
      :colorClass="colorFromEntry(schema)"
      :channelColor="schema.channel_color"
      :sharedInChannel="schema.is_shared"
    />
    <div class="flex flex-col truncate text-left">
      <span class="truncate text-5.5pt leading-5" :title="schema.title">
        {{ schema.title }}
      </span>
      <span class="-mt-1 truncate text-4.5pt">
        {{ paragraphTitle }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ISchema } from "~/models/IUserEntry";

type Props = {
  active: boolean;
  showIcon: boolean;
  schema: ISchema;
};

const props = defineProps<Props>();

const { colorFromEntry } = useColorFromEntry();

const { title: paragraphTitle } = useFullParagraphTitle(
  () => props.schema.legal_text_paragraph,
  true
);
</script>
